export default "__VITE_ASSET__BMyoBZfN__"